export type Theme = 'system' | 'dark' | 'bright';
export const THEME_KEY = 'repwise.theme';

export function applyTheme(t?: Theme): void {
  let theme = t;
  if (!theme) {
    try {
      theme = (localStorage.getItem(THEME_KEY) as Theme | null) ?? 'dark';
    } catch {
      theme = 'dark';
    }
  }
  document.documentElement.dataset.theme = theme;
}
